import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';
import DashboardPage from './pages/DashboardPage';
import PQRSPage from './pages/PQRSPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import MaintenancePage from './pages/MaintenancePage';
import EmergenciesPage from './pages/EmergenciesPage';
import PackagesPage from './pages/PackagesPage';
import BookingsPage from './pages/BookingsPage';
import FinancesPage from './pages/FinancesPage';
import BuildingsPage from './pages/BuildingsPage';
import ResidentsPage from './pages/ResidentsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import ProfilePage from './pages/ProfilePage';
import DocumentsPage from './pages/DocumentsPage';

// Super Admin Pages
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import BuildingRequestsPage from './pages/BuildingRequestsPage';
import InviteAdminPage from './pages/InviteAdminPage';
import SuperAdminUsersPage from './pages/SuperAdminUsersPage';
import SuperAdminBuildingsPage from './pages/SuperAdminBuildingsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/accept-invitation" element={<AcceptInvitationPage />} />

          {/* Super Admin Routes */}
          <Route
            path="/super-admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <SuperAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/solicitudes"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <BuildingRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/invitar-admin"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <InviteAdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/usuarios"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <SuperAdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/super-admin/conjuntos"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <SuperAdminBuildingsPage />
              </ProtectedRoute>
            }
          />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buildings"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BuildingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/residents"
            element={
              <ProtectedRoute allowedRoles={['admin', 'staff']}>
                <ResidentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pqrs"
            element={
              <ProtectedRoute allowedRoles={['admin', 'resident']}>
                <PQRSPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/announcements"
            element={
              <ProtectedRoute allowedRoles={['admin', 'resident']}>
                <AnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/maintenance"
            element={
              <ProtectedRoute allowedRoles={['admin', 'staff']}>
                <MaintenancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings"
            element={
              <ProtectedRoute allowedRoles={['admin', 'resident']}>
                <BookingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finances"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <FinancesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/packages"
            element={
              <ProtectedRoute allowedRoles={['admin', 'staff', 'resident']}>
                <PackagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/emergencies"
            element={
              <ProtectedRoute>
                <EmergenciesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/perfil"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/conjuntos"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <BuildingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
                <DocumentsPage />
              </ProtectedRoute>
            }
          />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;